"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function patchValue(data, field, fieldValue) {
    data.tip[field] = fieldValue;
    if (field === '::tip::') {
        data.parentArray[data.currentIndex] = fieldValue;
    }
}
exports.patchValue = patchValue;
